import {InMemoryCache} from '@apollo/client';
import {messageHistory} from './fieldPolicy/messageHistory';
import {getMessageHistory} from './fieldPolicy/getMessageHistory';
import {node} from './fieldPolicy/node';
import {followUpChats} from './fieldPolicy/followUpChats';
import {hasMoreFollowUps} from './fieldPolicy/hasMoreFollowUps';
import {hasMoreMessages} from './fieldPolicy/hasMoreMessages';
import {hasMoreClients} from './fieldPolicy/hasMoreClients';
import {hasMoreStaff} from './fieldPolicy/hasMoreStaff';
import {clients} from './fieldPolicy/clients';
import {staff} from './fieldPolicy/staff';
import {source, destination} from './fieldPolicy/Message';
import {unreadMessages} from './fieldPolicy/unreadMessages';
import {unreadCount} from './fieldPolicy/unreadCount';

/**
 * Initialize an Apollo cache.
 *
 * The cache is heavily tuned with merge/read logic. A plain instance of the
 * InMemoryCache will *not* work with Nudge!
 */
export const initCache = () =>
  new InMemoryCache({
    typePolicies: {
      StaffAccount: {
        fields: {
          unreadCount,
          followUpChats,
          hasMoreFollowUps,
        },
      },
      ClientAccount: {
        fields: {
          messageHistory,
          unreadMessages,
        },
      },
      AssociateAccount: {
        fields: {
          messageHistory,
        },
      },
      Message: {
        fields: {
          destination,
          source,
        },
      },
      Query: {
        fields: {
          getMessageHistory,
          node,
          hasMoreMessages,
          hasMoreClients,
          hasMoreStaff,
          clients,
          staff,
        },
      },
    },
  });

/**
 * Type of the Nudge Cache.
 */
export type NudgeCache = ReturnType<typeof initCache>;
